import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "detail_container"
}
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "基本信息", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 终止 ")
const _hoisted_9 = { class: "card-white-6 hw_detail_table_container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Demand配置 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Supply配置 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 导入 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 添加 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_16 = {
  key: 0,
  class: "card-white-6 hw_detail_table_container"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "hw_detail_table_header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "提示信息")
], -1)
const _hoisted_18 = { class: "link_container" }
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "link_wrapper" }
const _hoisted_21 = {
  key: 1,
  class: "card-white-6 hw_detail_table_container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_page_detail_wrapper, { title: _ctx.title }, {
    default: _withCtx(() => [
      (!_ctx.isEmptyData(_ctx.detail_data))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", null, [
                  (_ctx.isGod && _ctx.editMode === false)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        type: "primary",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMode = !_ctx.editMode))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editMode = false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.editMode)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 2,
                        type: "primary",
                        onClick: _ctx.submitEdit
                      }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
                !_ctx.isEmptyData(_ctx.detail_data.flow) && !['Done', 'Canceled'].includes(_ctx.detail_data.flow.current_state_key)
              )
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 3,
                        type: "primary",
                        onClick: _ctx.cancelMS
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode(_component_a_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "地区",
                            name: "region_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.getTextFromValue(_ctx.region_type_list, _ctx.detail_data.region_type, 'id', 'name')
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "业务类型",
                            name: "business_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.translateCommonList('ml_business', _ctx.detail_data.business_type)
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "平台",
                            name: "platform"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.translateCommonList('ml_platform', _ctx.detail_data.platform)
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "申请人",
                            name: "rd_owner_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.detail_data.rd_owner_name
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        span: 8,
                        xxl: 6
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "申请时间",
                            name: "create_time"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.detail_data.create_time
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.isEmptyData(_ctx.detail_data.flow))
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "状态",
                                name: "current_state_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.detail_data.flow.current_state_name
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ([_ctx.isMB, _ctx.isPD].includes(_ctx.detail_data.business_type) && _ctx.detail_data.region_type === _ctx.is_china)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "产品Code",
                                name: "code"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.detail_data.code
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail_data.business_type === _ctx.isPD)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 2,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "投放方式",
                                name: "delivery_method"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.getTextFromValue(_ctx.get_ml_delivery_method, _ctx.detail_data.delivery_method, 'id', 'name')
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (['FB', 'Adwords'].includes(_ctx.detail_data.platform))
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 3,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "海外户",
                                name: "is_foreign_account"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.detail_data.is_foreign_account ? '是' : '否'
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (['Adwords', 'TikTok'].includes(_ctx.detail_data.platform))
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 4,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "端口类型",
                                name: "port_type"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.detail_data.port_type,
                                    edit: _ctx.editMode
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_select, {
                                        value: _ctx.detail_data_edit.port_type,
                                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail_data_edit.port_type) = $event)),
                                        options: [
                      { text: 'webeye', value: 'webeye' },
                      { text: 'nonwebeye', value: 'nonwebeye' },
                    ]
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  }, 8, ["value", "edit"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ([_ctx.isPD, _ctx.isMB].includes(_ctx.detail_data.business_type) && _ctx.detail_data.region_type === _ctx.is_china)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 5,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "代理商",
                                name: "rd_agency_name_list"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.detail_data.rd_agency_name_list
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.detail_data.region_type === _ctx.is_china && _ctx.detail_data.business_type === _ctx.isMB)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 6,
                            span: 8,
                            xxl: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "客户AM",
                                name: "am_id"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.getTextFromValue(_ctx.demand_am_list, _ctx.detail_data.am_id, 'id', 'name')
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.isEmptyData(_ctx.detail_data))
                ? (_openBlock(), _createBlock(_component_we_table, {
                    key: 0,
                    onRegister: _ctx.register,
                    columns: _ctx.columns,
                    onFetchSuccess: _ctx.getMessageTip
                  }, {
                    headerButton: _withCtx(() => [
                      (!_ctx.isEmptyData(_ctx.detail_data.flow) && _ctx.detail_data.business_type === _ctx.isMB)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            class: "mglf-16",
                            type: "primary",
                            disabled: _ctx.detail_data.flow.current_state_key !== 'Contract Config',
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleEditAccount('Demand配置')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (
                !_ctx.isEmptyData(_ctx.detail_data.flow) &&
                [_ctx.isMB, _ctx.isPD].includes(_ctx.detail_data.business_type) &&
                _ctx.detail_data.region_type === _ctx.is_foreign
              )
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            class: "mglf-16",
                            type: "primary",
                            disabled: _ctx.detail_data.flow.current_state_key !== 'Contract Config',
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleEditAccount('Supply配置')))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (
                !_ctx.isEmptyData(_ctx.detail_data.flow) && !['Done', 'Canceled'].includes(_ctx.detail_data.flow.current_state_key)
              )
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 2,
                            onClick: _ctx.handleEdit,
                            type: "primary",
                            disabled: _ctx.detail_data.flow.current_state_key === 'CMS Apply'
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.canShowImport)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 3,
                            class: "mglf-16",
                            type: "primary",
                            onClick: _ctx.handleAutoButtonClick,
                            disabled: !['Append Account', 'BD Add Account'].includes(_ctx.detail_data.flow.current_state_key)
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }, 8, ["onClick", "disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.canShowAdd)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 4,
                            class: "mglf-16",
                            type: "primary",
                            disabled: !['Append Account', 'BD Add Account'].includes(_ctx.detail_data.flow.current_state_key),
                            onClick: _ctx.handleManualButtonClick
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.is_show_delete)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 5,
                            type: "primary",
                            onClick: _ctx.deleteAccount,
                            danger: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["onRegister", "columns", "onFetchSuccess"]))
                : _createCommentVNode("", true)
            ]),
            (
          _ctx.detail_data.business_type !== _ctx.isPD &&
          !_ctx.isEmptyData(_ctx.detail_data.flow) &&
          ['Contract Config'].includes(_ctx.detail_data.flow.current_state_key) &&
          _ctx.tip_message_list.items.length > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.tip_message_list.suffix), 1),
                    _createElementVNode("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tip_message_list.items, (item) => {
                        return (_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          key: item.contract_id,
                          onClick: ($event: any) => (_ctx.jumpToContract({ id: item.contract_id }))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.contract__name), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEmptyData(_ctx.detail_data.flow))
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createVNode(_component_FlowTimeLine, {
                    flow: _ctx.detail_data.flow,
                    onOnCatchFlag: _ctx.catchFlowFlag,
                    onOnUpdate: _ctx.initData
                  }, null, 8, ["flow", "onOnCatchFlag", "onOnUpdate"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_modal, {
              visible: _ctx.dialogVisible,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogVisible) = $event)),
              title: "选择代理",
              centered: "",
              onOk: _ctx.handleSelectedAgency,
              width: "800px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_form_item, { label: "代理列表" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        value: _ctx.selected_agency_list,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected_agency_list) = $event)),
                        mode: "multiple",
                        placeholder: "代理列表,多选",
                        options: _ctx.agency_list,
                        onChange: _ctx.initAgencyDataSource
                      }, null, 8, ["value", "options", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_we_table, _mergeProps({ dataSource: _ctx.agency_datasource }, _ctx.agencyTableConfig), {
                    contract_id: _withCtx(({ record }) => [
                      _createVNode(_component_we_select, {
                        value: record.contract_id,
                        "onUpdate:value": ($event: any) => ((record.contract_id) = $event),
                        options: record.contract_items,
                        onChange: (v) => _ctx.saveDataSource(v, record)
                      }, null, 8, ["value", "onUpdate:value", "options", "onChange"])
                    ]),
                    _: 1
                  }, 16, ["dataSource"])
                ])
              ]),
              _: 1
            }, 8, ["visible", "onOk"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"])), [
    [_directive_loading, _ctx.isEmptyData(_ctx.detail_data)]
  ])
}